import { Directions } from '../../../../common';
import { styled } from '@mui/material/styles';

export const TagContainer = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: '4px',
    padding: '2px 8px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    color: 'rgba(0, 0, 0, 0.9)',
    fontSize: '0.8125rem',
    '&:hover .remove-button': {
        opacity: 1,
    },
}));

export const RemoveButton = styled('span')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    right: theme.direction === Directions.rtl ? undefined : '4px',
    left: theme.direction === Directions.rtl ? '4px' : undefined,
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    opacity: 0,
    transition: 'opacity 0.2s',
    backgroundColor: 'rgba(182, 181, 181, 0.9)',
    borderRadius: '50%',
    padding: '2px',
}));
